// PrimeUI Community License key, passed to the PrimeVue plugin in both bootstraps
// (main.ts and glossary-main.ts). Without it, PrimeVue 5 renders a red
// "Invalid PrimeUI License" banner in the bottom-right of every page.
//
// This is not a secret. The key is Ed25519-signed and verified offline with no
// network call, and is designed to ship in the client bundle — unlike the VITE_*
// vars, there is nothing here to leak or rotate.
//
// Community License eligibility is re-confirmed annually at
// https://primeui.dev/licenses/community
export const PRIMEVUE_LICENSE = "eyJpZCI6Ijc2MWRhYzVlLWE0OTAtNGUzZi1hNjgwLTJhNjhmYWY2NjFmZSIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODUxNzU1MzUsImV4cCI6MTgxNjcxMTUzNX0.fEg98NNzL8Z0HyXjaMoKhtlInT3o1MyyJ8VDag9rtOWxL_rw3CzKBGe6LfwWr1kaFyWSh5yJFz7jxsExbW_aBQ"
